import { useEffect, useState } from "react";
import { Select } from "antd";
import ApplicationsView from "./ApplicationsView";
import RegistrationsView from "./RegistrationsView";

const JobSeekerDashboard = ({ callback = false }) => {
  const [activeView, setActiveView] = useState("applications");

  useEffect(() => {
    if (callback) {
      callback("Job Seeker Analytics");
    }
  }, []);

  const handleViewChange = (value) => {
    setActiveView(value);
  };

  return (
    <div>
      <div className="divide-y divide-warmgray-300">
        <div className="flex flex-col">
          <div>
            <div className="flex justify-between items-center pt-4 pb-2">
              <h3 className="text-xl font-medium leading-6 text-gray-900">
                Job Seeker Analytics
              </h3>

              {/* Dropdown to switch between views */}
              <div className="flex items-center space-x-2">
                <span className="text-sm text-gray-500">View:</span>
                <Select
                  defaultValue="applications"
                  value={activeView}
                  onChange={handleViewChange}
                  style={{ width: 180 }}
                  options={[
                    { value: "applications", label: "Applications" },
                    { value: "registrations", label: "Registrations" },
                  ]}
                />
              </div>
            </div>

            {/* Render active view */}
            {activeView === "applications" ? (
              <ApplicationsView />
            ) : (
              <RegistrationsView />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobSeekerDashboard;
